<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <base-chip
          v-bind="$props"
          :color="colorScheme"
          :icon="icon"
          :text="showText ? text : ''"
          :class="$attrs.class"
          v-on="showTooltip ? on : null"
        />
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { VChip } from 'vuetify/lib'

import BaseChip from '@/components/chips/base-chip'

export default {
  name: 'NewsPublishedChip',
  components: {
    BaseChip,
  },
  extends: VChip,
  props: {
    showText: {
      type: Boolean,
      default: true,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorScheme() {
      switch (this.value) {
        case 'publish':
          return 'success'
        case 'pending':
          return 'green lighten-4'
        case 'draft':
          return 'warning'
        default:
          return 'error'
      }
    },
    icon() {
      switch (this.value) {
        case 'publish':
          return 'check'
        case 'pending':
          return 'pending'
        case 'draft':
          return 'edit'
        default:
          return 'close'
      }
    },
    text() {
      switch (this.value) {
        case 'publish':
          return 'Published'
        case 'pending':
          return 'Pending Review'
        case 'draft':
          return 'Draft'
        default:
          return 'No Translation'
      }
    },
  },
}
</script>
